import React, { useCallback, useState } from 'react';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import { ImageSource } from '../../DeviationViews/Full/types';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import { DefaultArtStageProps as Props } from '../types';
import MobileMultiArtStage from './MobileMultiArtStage';
import MobileSingleArtStage from './MobileSingleArtStage';

export const MobileArtStage: React.FC<Props> = props => {
  const hasAdditionalMedia = props.deviation.extended?.additionalMedia?.length;
  const shouldRenderMultiImage =
    isMultiImageDeviation(props.deviation) && hasAdditionalMedia;

  const [zoomedImageSource, setZoomedImageSource] = useState<
    ImageSource | undefined
  >();
  const logZoomBi = useZoomBiLogger(props.deviation);
  const zoomProps = {
    zoomedImageSource,
    isZoomed: !!zoomedImageSource,
    onEnterZoomMode: useCallback(
      source => {
        setZoomedImageSource(source);
        logZoomBi(true);
      },
      [logZoomBi]
    ),
    onExitZoomMode: useCallback(() => {
      setZoomedImageSource(undefined);
      logZoomBi(false);
    }, [logZoomBi]),
  };

  return shouldRenderMultiImage ? (
    <MobileMultiArtStage {...props} {...zoomProps} />
  ) : (
    <MobileSingleArtStage {...props} {...zoomProps} />
  );
};
MobileArtStage.displayName = 'MobileArtStage';
export default MobileArtStage;
